import { CancelablePromise, Document, Partner, SendDocument } from '@codingsans/billingo-client'

import { httpClient } from './clients/httpClient'
export interface StartPaymentProcessDTO {
    total: number
    currency?: string
    orderRef?: string
    language?: string
    methods?: string[]
    isComplimentary?: boolean
    url: string
    customer: {
        firstName: string
        lastName: string
        phoneNumber: string
        email: string
    }
    invoice: {
        country: string
        postCode: string
        city: string
        address: string
        taxNumber?: string
        companyName?: string
        type: string
    }
    event: {
        eventId: string
        ticketIds: string[]
    }
}

export type StartPaymentResponseWithStatus = {
    payment: {
        transactionId: number
        orderRef: string
        merchant: string
        timeout: string
        total: number
        paymentUrl: string
        currency: string
        salt: string
    }
    customer: {
        firstName: string
        lastName: string
        phoneNumber: string
        email: string
    }
    invoice: {
        country: string
        postCode: string
        city: string
        address: string
        taxNumber?: string
        companyName?: string
        type: string
    }
    event: {
        event_id: string
        ticket_ids: string[]
    }
    status: string
}

export type StartPaymentResponseWithStatusAndInvoice = {
    startPaymentResponse: StartPaymentResponseWithStatus
    invoiceResponse: InvoiceResponse
}

export type InvoiceResponse = {
    newPartner: Partner
    documentBlockId: number
    bankAccountId: number
    insertedDocument: Document
    sentEmail: CancelablePromise<SendDocument>
}

export interface TransactionStatusResponseDTO {
    status: string
    transactionId: string
}
export interface PaymentCallbackDTO {
    [key: string]: any
}

export const startPayment = async (paymentDetails: StartPaymentProcessDTO) => {
    if (paymentDetails.isComplimentary) {
        throw new Error('Tiszteletjegyek kiadása kizárólag adminisztrátori jogosultsággal lehetséges.')
    }

    try {
        const { data } = await httpClient.post('/otp/start-payment', paymentDetails)
        return data
    } catch (error: any) {
        console.error('Error starting payment:', error.response?.data || error.message)
        throw new Error('Fizetési folyamat elindítása nem sikerült.')
    }
}

export const startLocalSellingProcess = async (paymentDetails: StartPaymentProcessDTO): Promise<StartPaymentResponseWithStatus> => {
    try {
        const { data } = await httpClient.post<StartPaymentResponseWithStatus>('/otp/start-local-selling', paymentDetails)
        return data
    } catch (error: any) {
        console.error('Error starting local selling:', error.response?.data || error.message)
        throw new Error('Failed to start local selling')
    }
}

export const checkTransactionStatus = async (transactionId: string): Promise<TransactionStatusResponseDTO> => {
    if (!transactionId) {
        throw new Error('Please provide transactionId to check payment status.')
    }

    try {
        const { data } = await httpClient.post<TransactionStatusResponseDTO>('/otp/status', { transactionId })
        return data
    } catch (error: any) {
        console.error('Error checking payment status:', error.response?.data || error.message)
        throw new Error('Failed to check payment status')
    }
}
